import { Alert, Snackbar } from '@mui/material';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { RootState } from '../../reducers';
import { setShowMessage } from '../../store/shared.slice';
import { ERROR, SUCCESS } from '../../utils/constants';

export default function MessageDisplay() {
    const dispatch = useAppDispatch();
    const { message, messageType, showMessage } = useSelector((state: RootState) => state.shared);
    const autoHideDuration = messageType === ERROR ? 10_000 : 3000;
    return (
        <>
            {showMessage ? (
                <Snackbar
                    style={{ minWidth: '300px', maxWidth: '600px' }}
                    open={showMessage}
                    autoHideDuration={autoHideDuration}
                    onClose={() => dispatch(setShowMessage(false, '', SUCCESS))}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert
                        onClose={() => dispatch(setShowMessage(false, '', SUCCESS))}
                        variant="filled"
                        severity={messageType}
                        sx={{ width: '100%', whiteSpace: 'pre-line' }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            ) : null}
        </>
    );
}
